import React, { createContext, useContext, ReactNode } from 'react';
import { supabase, saveSimulation } from './supabaseClient';

interface SupabaseContextProps {
  saveSimulation: typeof saveSimulation;
}

const SupabaseContext = createContext<SupabaseContextProps | undefined>(undefined);

interface SupabaseProviderProps {
  children: ReactNode;
}

export const SupabaseProvider: React.FC<SupabaseProviderProps> = ({ children }) => {
  return (
    <SupabaseContext.Provider
      value={{
        saveSimulation
      }}
    >
      {children}
    </SupabaseContext.Provider>
  );
};

export const useSupabase = (): SupabaseContextProps => {
  const context = useContext(SupabaseContext);
  if (context === undefined) {
    throw new Error('useSupabase must be used within a SupabaseProvider');
  }
  return context;
}; 